import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useTresors } from "@/data/hooks";
import { useLanguage } from "@/i18n/LanguageContext";
import { FadeUp, Stagger, StaggerItem } from "@/components/Reveal";

export default function TresorsIndex() {
 const TRESORS = useTresors();
 const { locale } = useLanguage();
 const l = (fr, en, pt) => locale === "en" ? en : locale === "pt" ? pt : fr;
 return (
 <div data-testid="page-tresors">
 <section className="border-b border-nanda-line">
 <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 pt-24 md:pt-40 pb-20 md:pb-28 grid grid-cols-1 md:grid-cols-12 gap-10">
 <FadeUp className="md:col-span-4">
 <div className="label-overline text-nanda-muted">{l("Les Trésors", "The Treasures", "Os Tesouros")}</div>
 </FadeUp>
 <FadeUp delay={0.1} className="md:col-span-8">
 <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-balance leading-[1.0]">{l("Les Trésors d'Afrique de l'Ouest.", "The Treasures of West Africa.", "Os Tesouros da África Ocidental.")}</h1>
 <p className="mt-10 max-w-2xl text-nanda-inkSoft text-base md:text-lg leading-relaxed">
 {l(
 "Douze ingrédients d'exception. Chacun avec son histoire, sa récolte, son territoire et les produits NANDA SÁ qui l'utilisent.",
 "Twelve exceptional ingredients. Each with its story, its harvest, its territory and the NANDA SÁ products that use it.",
 "Doze ingredientes de excepção. Cada um com a sua história, a sua colheita, o seu território e os produtos NANDA SÁ que o utilizam."
 )}
 </p>
 </FadeUp>
 </div>
 </section>

 <section className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 py-16 md:py-24">
 <Stagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
 {TRESORS.map((t) => (
 <StaggerItem key={t.slug}>
 <Link to={`/tresors/${t.slug}`} data-testid={`tresor-row-${t.slug}`} className="group block relative aspect-[4/5] overflow-hidden border border-nanda-line">
 {t.image ? (
 <>
 <img src={t.image} alt={t.name} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105" />
 <div className="absolute inset-0 bg-gradient-to-t from-nanda-ink/80 via-nanda-ink/15 to-transparent" />
 </>
 ) : (
 <div className="absolute inset-0 bg-nanda-ink flex items-center justify-center">
 <span className="font-serif italic text-white/25 text-6xl md:text-7xl select-none tracking-tight">{t.latin.split("")[0]}</span>
 </div>
 )}
 <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-between">
 <div className="label-overline text-white/85">{t.territory}</div>
 <div>
 <div className="font-serif text-white text-3xl md:text-4xl">{t.name}</div>
 <div className="italic text-white/70 text-sm mt-2">{t.latin}</div>
 <p className="mt-3 text-white/85 text-sm max-w-xs">{t.teaser}</p>
 <span className="mt-5 inline-flex items-center gap-2 label-overline text-white group-hover:translate-x-1 transition-transform duration-500">{l("Découvrir", "Discover", "Descobrir")} <ArrowUpRight size={14} strokeWidth={1.5} /></span>
 </div>
 </div>
 </Link>
 </StaggerItem>
 ))}
 </Stagger>
 </section>
 </div>
 );
}
